@if (isOpen && currentStep && highlightRect) {
  <div class="tet-backdrop" (click)="skip()"></div>
  <div class="tet-highlight"
    [style.top.px]="highlightRect.top - 12"
    [style.left.px]="highlightRect.left - 12"
    [style.width.px]="highlightRect.width + 24"
    [style.height.px]="highlightRect.height + 24">
  </div>
  <div class="tet-tooltip tet-tooltip--{{ tooltipPosition.placement }}"
    [style.top.px]="tooltipPosition.top"
    [style.left.px]="tooltipPosition.left">
    <div class="tet-tooltip__title">{{ currentStep.titleKey | translate }}</div>
    <div class="tet-tooltip__message">{{ currentStep.messageKey | translate }}</div>
    <div class="tet-tooltip__footer">
      <span class="tet-tooltip__step-counter">{{ stepCounterText }}</span>
      <div class="tet-tooltip__actions">
        <button type="button" class="tet-tooltip__skip" (click)="skip()">
          {{ 'Skip tour' | translate }}
        </button>
        <button type="button" class="tet-tooltip__next" (click)="next()">
          {{ (isLastStep ? 'Got it' : 'Next') | translate }}
        </button>
      </div>
    </div>
  </div>
}
